import React from "react";
import {QuestionarioFazendaObject} from "../../../models/Questionario";
import EntityView from "../../../components/EntityView";
import {FormQuestionarioFazenda} from "./FormQuestionarioFazenda";
import {EventoObject} from "../../../models/Evento";
import QuestionarioCorteV1 from "./Fazenda/QuestionarioCorteV1";
import QuestionarioCorteV2 from "./Fazenda/QuestionarioCorteV2";
import QuestionarioLeiteV1 from "./Fazenda/QuestionarioLeiteV1";
import QuestionarioLeiteV2 from "./Fazenda/QuestionarioLeiteV2";
import QuestionarioLeiteV3 from "./Fazenda/QuestionarioLeiteV3";
import {FazendaObject} from "../../../models/Fazenda";
import FieldView from "../../../components/FieldView";
import {formDefFazenda} from "./forms";

interface Props {
  history: any;
  questionario: QuestionarioFazendaObject;
  onReload: () => void;
  onDelete: () => Promise<string | void>;
  evento: EventoObject;
  principal: FazendaObject;
  allowDelete: boolean;
}

export const QuestionarioFazenda: React.FC<Props> = (
  {
    questionario, onReload, onDelete, evento, principal,
    allowDelete,
  }) => {

  return (
    <>
      <EntityView
        instance={questionario}
        ModelForm={FormQuestionarioFazenda}
        modelFormProps={{evento, principal}}
        entityLabel="Questionário Fazenda"
        gender="m"
        onReload={onReload}
        onDelete={onDelete}
        allowDelete={allowDelete}
        allowEdit={allowDelete}
      >
        <div className="text-2xl font-bold mb-4">
          Questionário
        </div>
        {
          (!questionario.versao || questionario.versao === 1) &&
            <>
              {
                principal.tipo.indexOf('Corte') !== -1 &&
                  <QuestionarioCorteV1 questionario={questionario}/>
              }

              {
                principal.tipo.indexOf('Leite') !== -1 &&
                  <QuestionarioLeiteV1 questionario={questionario}/>

              }
            </>
        }
        {
          (questionario.versao && questionario.versao === 2) &&
            <>
              {
                principal.tipo.indexOf('Corte') !== -1 &&
                  <QuestionarioCorteV2 questionario={questionario} principal={principal}/>
              }

              {
                principal.tipo.indexOf('Leite') !== -1 &&
                  <QuestionarioLeiteV2 questionario={questionario}/>

              }
            </>
        }
        {
          (questionario.versao && questionario.versao === 3) &&
            <>
              {
                principal.tipo.indexOf('Corte') !== -1 &&
                  <QuestionarioCorteV2 questionario={questionario} principal={principal}/>
              }

              {
                principal.tipo.indexOf('Leite') !== -1 &&
                  <QuestionarioLeiteV3 questionario={questionario}/>

              }
            </>
        }

        <div className="text-xl font-hairline mt-6">
          Produtos utilizados
        </div>
        <FieldView value={questionario.vacina_reprodutiva} def={formDefFazenda.vacina_reprodutiva}/>
        <FieldView value={questionario.vacina_diarreia_pneumonia} def={formDefFazenda.vacina_diarreia_pneumonia}/>
        <FieldView value={questionario.mineral_injetavel} def={formDefFazenda.mineral_injetavel}/>

        <div className="text-xl font-hairline mt-6">
          Demais informações
        </div>
        <FieldView value={questionario.quantidade_animais} def={formDefFazenda.quantidade_animais}/>
        <FieldView value={questionario.faz_iatf} def={formDefFazenda.faz_iatf}/>
        <FieldView value={questionario.observacoes} def={formDefFazenda.observacoes}/>
      </EntityView>
    </>
  )
};
